import type { MySettings } from '@myrewards/contracts';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { mySettingsQuery } from '../api';

/**
 * My settings › Accessibility on every page: higher contrast and larger text, as attributes on
 * `<html>` that global.css reads. Standard values remove the attributes.
 */
export function applyAccessibility(a: MySettings['accessibility']): void {
  const html = document.documentElement;
  if (a.contrast === 'high') html.setAttribute('data-contrast', 'high');
  else html.removeAttribute('data-contrast');
  if (a.textSize === 'large') html.setAttribute('data-text-size', 'large');
  else html.removeAttribute('data-text-size');
}

/** Keeps the document in step with the person's accessibility choices while signed in. */
export function useApplyAccessibility(): void {
  const { data } = useQuery({ ...mySettingsQuery, staleTime: 5 * 60_000 });
  const contrast = data?.accessibility.contrast;
  const textSize = data?.accessibility.textSize;
  useEffect(() => {
    if (contrast === undefined || textSize === undefined) return;
    applyAccessibility({ contrast, textSize });
  }, [contrast, textSize]);
}
